import React from 'react';
import { Button } from '../../components/ui/Button';
export function ContactHeaderSection() {
  return <section className="pt-16 md:pt-24 pb-8 bg-white" data-id="element-2593">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2594">
        <div className="text-center" data-id="element-2595">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-2596">
            Contact Peak Machine Sales
          </h2>
          <p className="text-lg text-gray-600 mb-6" data-id="element-2597">
            Tell us what you're looking for and our team will respond.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-2598">
            <Button variant="primary" size="lg" href="tel:2483800871" data-id="element-2599">
              Call (248) 380-0871
            </Button>
            <Button variant="secondary" size="lg" href="59m7/used-machines.html" data-id="element-2600">
              Browse Used Inventory
            </Button>
          </div>
        </div>
      </div>
    </section>;
}